// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/* Variables for Instec */\n[data-v-0fc17bf2]:export {\n  menuBg: #0F4C81;\n  menuText: #ffffff;\n  menuActiveText: #0F4C81;\n  menuActiveBg: #ffffff;\n}\n\n/* Mixins */\n.app-main .form-block.import-block[data-v-0fc17bf2] {\n  width: 90%;\n}\n.centered-count[data-v-0fc17bf2] {\n  padding: 1em;\n}\n.failed-product-item[data-v-0fc17bf2] {\n  display: inline-block;\n  margin-bottom: 5px;\n  margin-right: 5px;\n}", ""]);
// Exports
module.exports = exports;
